import { type Cart as CartData } from "@cappelendamm/e-commerce-services";

export const getCartNumberOfItems = (cart: CartData | null) =>
  getNumberOfItems(cart?.items.filter((item) => !isFreightItem(item)) ?? []);

export const getCartTotalDiscount = (
  cart: CartData | null,
): { total: number | null; totalDiscount: number | null } => {
  const freightPrice = getCartFreightPrice(cart);
  return getTotalDiscount({
    total: cart?.total.gross ? cart.total.gross - (freightPrice ?? 0) : null,
    items:
      cart?.items
        .filter((item) => !isFreightItem(item))
        .map(({ originalPrice, quantity }) => ({
          originalPrice,
          quantity,
        })) ?? [],
  });
};

export const isFreightItem = (item: CartData["items"][number]) =>
  item.variant.product.path.startsWith("/pim/fraktregler");

export const getCartFreightPrice = (cart: CartData | null) => {
  const freightItems = cart?.items.filter(isFreightItem);
  if (!freightItems || freightItems.length === 0) return null;
  return freightItems.reduce((acc, cur) => {
    return acc + cur.price.gross;
  }, 0);
};

export const getNumberOfItems = (items: { quantity: number }[]) =>
  items.reduce((acc, cur) => acc + cur.quantity, 0) ?? 0;

export const getTotalDiscount = ({
  total,
  items,
}: {
  total: number | null | undefined;
  items: { originalPrice: number | null | undefined; quantity: number }[];
}): { total: number | null; totalDiscount: number | null } => {
  if (!total) return { total: null, totalDiscount: null };
  const originalTotal = items.reduce((acc, cur) => {
    if (!cur.originalPrice) return acc;
    return acc + cur.originalPrice * cur.quantity;
  }, 0);
  if (originalTotal > total)
    return {
      total: originalTotal,
      totalDiscount: originalTotal - total,
    };
  return { total: total, totalDiscount: null };
};
